import React, { useMemo } from 'react';
import PropTypes from 'prop-types';

const Pagination = ({ currentPage, totalPages, onPageChange }) => {
    const pageNumbers = useMemo(() => {
        return Array.from({ length: totalPages }, (_, i) => i + 1);
    }, [totalPages]);

    const handlePageClick = (page) => {
        if (page !== currentPage) {
            onPageChange(page);
        }
    };

    const isFirstPage = currentPage === 1;
    const isLastPage = currentPage === totalPages;

    return (
        <div className="pagination__wrapper">
            <nav className="pagination__nav" aria-label="Page navigation">
                <button
                    type="button"
                    className="pagination__button pagination__button--prev"
                    onClick={() => handlePageClick(currentPage - 1)}
                    disabled={isFirstPage}
                    aria-label="Previous page"
                >
                    &lt;
                </button>

                {pageNumbers.map((number) => (
                <button
                    key={number}
                    type="button"
                    className={`pagination__button ${
                    currentPage === number ? 'pagination__button--active' : ''
                    }`}
                    onClick={() => handlePageClick(number)}
                    disabled={currentPage === number}
                    aria-current={currentPage === number ? 'page' : undefined}
                >
                    {number}
                </button>
                ))}

                <button
                type="button"
                className="pagination__button pagination__button--next"
                onClick={() => handlePageClick(currentPage + 1)}
                disabled={isLastPage}
                aria-label="Next page"
                >
                    &gt;
                </button>
            </nav>
        </div>
    );
};

Pagination.propTypes = {
  currentPage: PropTypes.number.isRequired,
  totalPages: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
};

export default Pagination;
